import React, { useEffect, useState } from 'react'

import { useFreeSpinsBonusesStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import { BonusSystemState, Bonus, GameUIMessageType, BonusesPlayLaterMessage } from 'game-ui-types'
import { showFlexiBundles } from '@amusnet/react-ui'

interface FSViewOptionsProps {
    bonus?: Bonus
}

const FSViewOptionsButtons: React.FC<FSViewOptionsProps> = ({ bonus }: FSViewOptionsProps) => {
    const bonusSystemState = useFreeSpinsBonusesStore((state) => state.bonusSystemState)
    const setBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const bonuses = useFreeSpinsBonusesStore((state) => state.bonuses)
    const setShowFlexiIntroModal = useFreeSpinsBonusesStore((state) => state.setShowFlexiIntroModal)
    const showFlexiIntroModal = useFreeSpinsBonusesStore((state) => state.showFlexiIntroModal)

    const { t } = useTranslation()

    const [primaryButtonText, setPrimaryButtonText] = useState('')
    const [secondaryButtonText, setSecondaryButtonText] = useState('')

    const isInSingleBonusState = bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL
    const canPlayLater = isInSingleBonusState ? bonus?.playLater : bonuses.every((b) => b.playLater)

    useEffect(() => {
        switch (bonusSystemState) {
            case BonusSystemState.SINGLE_BONUS_INITIAL: {
                setPrimaryButtonText(t('gameui.betOptions_uppercase'))
                setSecondaryButtonText(t('gameui.playLater'))
                break
            }
        }
    }, [bonusSystemState])

    const viewOptionsHandler = () => {
        setShowFlexiIntroModal(false)
    }

    const playLaterHandler = () => {
        if (isInSingleBonusState && !bonus) {
            return
        }

        if (showFlexiBundles && showFlexiIntroModal) {
            setShowFlexiIntroModal(false)
        }

        if (isInSingleBonusState) {
            const message: BonusesPlayLaterMessage = {
                type: GameUIMessageType.BONUSES_PLAY_LATER,
                payload: { bonusIds: bonuses.map((b) => b.id) },
            }

            window.postMessage(message)
            setBonusSystemState(BonusSystemState.INACTIVE)
        }
    }

    return (
        <>
            <div className="flex justify-center gap-[20px] w-full px-[77px] pt-[24px] pb-[24px]">
                {canPlayLater && (
                    <BSModalButton
                        id={secondaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                        text={secondaryButtonText}
                        isPrimary={false}
                        onClick={playLaterHandler}
                    />
                )}
                <BSModalButton
                    id={primaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                    text={primaryButtonText}
                    onClick={viewOptionsHandler}
                />
            </div>
        </>
    )
}

export default FSViewOptionsButtons
